class RelativeParser {
    static pixelsToPercentage(x, y, parentWidth, parentHeight) {

        return {
            x: ((x * 100) / parentWidth),
            y: ((y * 100) / parentHeight)
        }
    }

    static percentageToPixels(x, y, parentWidth, parentHeight) {

        if (x.includes('%')) x = x.replace('%', '');
        if (y.includes('%')) y = y.replace('%', '');

        return {
            x: ((x * parentWidth) / 100),
            y: ((y * parentHeight) / 100)
        }
    }
}
export default RelativeParser;